/**
 * Company: SPHMedia
 * Description: [Follow trending topic Toast Message Component]
 */
import Cross from "@assets/icons/close.svg";
import SuccessIcon from "@assets/icons/success-green.svg";
import { ReactElement } from "react";

import useFollowTopicToast from "./hooks/useFollowTopicsToast";

type FollowTrendingTopicToastMsgProps = {
  followedCount: number;
  forceShowToast?: boolean;
};

/**
 * FollowTrendingTopicToastMsg
 * Description: [Toast message component for following trending topics]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function FollowTrendingTopicToastMsg({
  followedCount,
  forceShowToast,
}: FollowTrendingTopicToastMsgProps): ReactElement {
  const { hide, handleClose } = useFollowTopicToast({ forceShowToast });

  const message = `${followedCount} topik telah diikuti`;

  return (
    <div
      data-testid="follow-trending-topics-success-toast"
      className={`fixed left-1/2 -translate-x-1/2 z-[99] top-[125px] lg:top-[175px]
      flex gap-2 w-full items-center py-2 px-3 max-w-[358px] bg-blue-450 
      rounded-[8px] shadow-[0_0_12px_0_rgba(0,0,0,0.5)] transition-all duration-500 ease-in-out
      ${hide ? "opacity-0 translate-y-4 pointer-events-none" : "opacity-100 translate-y-0"}
    `}
    >
      <div data-testid="toast-icon" className="flex items-center">
        <img src={SuccessIcon} alt="success-icon" width={24} />
      </div>
      <div
        data-testid="toast-message"
        className="flex flex-grow-no-shrink items-start text-xs text-white-100"
      >
        <p className="font-semimedium leading-[150%] ">{message}</p>
      </div>
      <div className="flex items-center">
        <button
          data-testid="toast-close-button"
          onClick={() => {
            handleClose();
          }}
        >
          <img src={Cross} alt="close-icon" width={16} />
        </button>
      </div>
    </div>
  );
}
